import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrustContentModule } from '../../../pipes/trust-content/trust-content.module';
import { StepModule } from '../../atoms/step/step.module';
import { StepSectionComponent } from './step-section.component';

@NgModule({
  imports: [CommonModule, StepModule, TrustContentModule],
  declarations: [StepSectionComponent],
  exports: [StepSectionComponent]
})
export class StepSectionModule {}
